exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 768px)\n{\n    .mobileIndexHide\n    {\n        display: none;\n    }\n}\n\n@media (min-width: 768px)\n{\n    .desktopIndexHide\n    {\n        display: none;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/index/index.component.css
// module id = ../../../../../src/app/components/index/index.component.css
// module chunks = main